var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2.39062L19.3517 8.53091L18.5284 9.78478L17.3095 8.9844V17.457H2.68945V8.98522L1.47173 9.78478L0.648438 8.53091L10.0001 2.39062ZM10.0001 4.18507L15.8095 7.9995V15.957H11V13.7461H9V15.957H4.18945V8.00033L10.0001 4.18507Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayHomeIcon);
export default __webpack_public_path__ + "static/media/overlay_home_icon.82ca356ddee8c3bc8ebac6b61d98c363.svg";
export { ForwardRef as ReactComponent };